import {observable, action, runInAction} from 'mobx'
import {get} from '../../../../utils/ajax'
import {message} from "antd/lib/index";

class ToolMethodStore {
    @observable loading;
    @observable content;
    @observable otherId;
    @observable downList;

    constructor() {
        this.loading = false;
        this.content = '';
        this.otherId = '';
        this.downList = [];

    }

    /*** 根据条件或无条件分页请求接口加载数据*/
    @action
    initPage = async () => {
        runInAction(() => {
            this.loading = true
        })
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/specialTool/annexContent`)
        if (res && res.status === 0) {
            message.error(res.msg)
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.content = res.content || [];
            this.otherId = res.id || '';
            this.loading = false
        })
        this.initTable(this.otherId)
    }

    initTable = async (value) => {
        const ress = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/specialTool/annex/list?otherId=${this.otherId}`)
        runInAction(() => {
            this.downList = ress || []
        })
    }

}

export default new ToolMethodStore()


// WEBPACK FOOTER //
// ./src/project/dongfeng/toolkit/ToolMethod/store.js